var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidationInvalid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76159 4.69325L4.70093 5.75391L13.4266 14.4796L14.4873 13.4189L5.76159 4.69325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4266 4.69325L4.70093 13.4189L5.76159 14.4796L14.4873 5.75391L13.4266 4.69325Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 19.18H5.93C5.73115 19.1798 5.54052 19.1007 5.4 18.96L0.220001 13.78C0.0793087 13.6395 0.000175052 13.4488 0 13.25V5.93C0.000175052 5.73115 0.0793087 5.54052 0.220001 5.4L5.4 0.22C5.54052 0.0793075 5.73115 0.000175052 5.93 0H13.25C13.4488 0.000175052 13.6395 0.0793075 13.78 0.22L18.96 5.4C19.1007 5.54052 19.1798 5.73115 19.18 5.93V13.25C19.1798 13.4488 19.1007 13.6395 18.96 13.78L13.78 18.96C13.6395 19.1007 13.4488 19.1798 13.25 19.18ZM6.25 17.68H12.95L17.66 12.94V6.24L12.94 1.5H6.24L1.5 6.24V12.94L6.25 17.68Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationInvalid);
export default __webpack_public_path__ + "static/media/ValidationInvalid.a3c852a0.svg";
export { ForwardRef as ReactComponent };